import {
  CAMPAIGNS_RESOURCE_NAME,
  CREATE_AND_SEND,
  CREATE_DRAFT, SEND_CAMPAIGN, UPDATE_DRAFT
} from '../../../config/constants';
import MESSAGES from '../../../locale/messages';
import { ApiError } from '../../../utils/errors';
import { message } from 'antd';
import TEXTS from '../../../locale/texts';

// this function is member of NewCampaign component
const actionsCampaign = function(actionName) {
  const { lang, promiseCancelToken, addNotification } = this.props;
  const { PAYLOAD } = this.state;

  // todo: make null for smsBodyMeta if withData is absent

  const newCampaignData = (_PAYLOAD) => {
    let data = _PAYLOAD;

    if (!_PAYLOAD.isMsisdnsWithData) {
      data = {
        ...data,
        msisdns: data.msisdns.map(({ msisdn }) => ({
          msisdn, param1: '', param2: '', param3: '', param4: ''
        }))
      }
    }

    // we dont need id when
    // creating new campaign
    delete data.id;

    return data;
  };

  // CREATE NEW CAMPAIGN AND SEND IT IMMEDIATELY
  const createAndSendCampaign = () => {
    this.callResource({
      resourceName: CAMPAIGNS_RESOURCE_NAME,
      apiClassName: 'campaigns',
      action: 'createAndSend',
      apiCallParams: newCampaignData(PAYLOAD),
      promiseCancelToken,
      onSuccess: ({ data }) => {
        const nWhiteList = data.whiteListCount;
        const nBlackList = data.blackListCount;
        addNotification(
          `${MESSAGES.campaignIsSendToContacts(PAYLOAD.name, nWhiteList)[lang]}, ${MESSAGES.campaignFoundInBlackListContacts(nBlackList)[lang]}`
        );
        this.hideDrawer();
        this.toAllCampaigns();
      },
      onError: (err) => {
        const { errorMessage } = new ApiError(err);
        if( err?.response?.status === 413 && err?.response?.data?.message === 'Request Entity Too Large') {
          message.error(`${TEXTS.campaignWasNotSent[lang]}: ${TEXTS.campaignContactNumberOutOfLimit[lang]}.`, 10);
        }
        else {
          message.error(`${TEXTS.campaignWasNotSent[lang]}: ${errorMessage}.`, 10);
        }
        this.hideDrawer();
      }
    });
  };

  // CREATE DRAFT CAMPAIGN, WITHOUT SENDING IT YET
  const createDraftCampaign = () => {
    this.callResource({
      resourceName: CAMPAIGNS_RESOURCE_NAME,
      apiClassName: 'campaigns',
      action: 'createDraft',
      apiCallParams: newCampaignData(PAYLOAD),
      promiseCancelToken,
      onSuccess: () => {
        addNotification(MESSAGES.campaignDraftNameIsSaved(PAYLOAD.name)[lang]);
        this.hideDrawer();
        this.toAllCampaigns();
      },
      onError: (err) => {
        const { errorMessage } = new ApiError(err);
        message.error(`${TEXTS.campaignWasNotSaved[lang]}: ${errorMessage}.`, 10);
        this.hideDrawer();
      }
    });
  };

  // SAVE EDITED DRAFT CAMPAIGN
  const updateDraftCampaign = () => {
    this.callResource({
      resourceName: CAMPAIGNS_RESOURCE_NAME,
      apiClassName: 'campaigns',
      action: 'updateDraft',
      apiCallParams: PAYLOAD,
      promiseCancelToken,
      onSuccess: () => {
        addNotification(MESSAGES.campaignDraftNameIsSaved(PAYLOAD.name)[lang]);
        this.hideDrawer();
        this.toAllCampaigns();
      },
      onError: (err) => {
        const { errorMessage } = new ApiError(err);
        message.error(`${TEXTS.campaignWasNotSaved[lang]}: ${errorMessage}.`, 10);
        this.hideDrawer();
      }
    });
  };

  // SEND PREVIOUSLY SAVED DRAFT CAMPAIGN
  // backend doesnt work on than one yet
  const sendCampaign = () => {
    this.callResource({
      resourceName: CAMPAIGNS_RESOURCE_NAME,
      apiClassName: 'campaigns',
      action: 'send',
      apiCallParams: PAYLOAD,
      promiseCancelToken,
      onSuccess: ({ data }) => {
        const { lang } = this.props;
        const nWhiteList = data.whiteListCount;
        const nBlackList = data.blackListCount;
        const whiteListTitle = MESSAGES.campaignIsSendToContacts(PAYLOAD.name, nWhiteList)[lang];
        const blackListTitle = MESSAGES.campaignFoundInBlackListContacts(PAYLOAD.name, nBlackList)[lang];
        addNotification(`${whiteListTitle}, ${blackListTitle}`);

        this.hideDrawer();
        this.toAllCampaigns();
      },
      onError: (err) => {
        const { errorMessage } = new ApiError(err);
        message.error(`${TEXTS.campaignWasNotSent[this.props.lang]}: ${errorMessage}.`, 10);
        this.hideDrawer();
      }
    });
  };

  switch(actionName) {
    case CREATE_AND_SEND:
      return createAndSendCampaign();
    case CREATE_DRAFT:
      return createDraftCampaign();
    case UPDATE_DRAFT:
      return updateDraftCampaign();
    case SEND_CAMPAIGN:
      return sendCampaign();
    default:
      return null;
  }
};

export { actionsCampaign };
